import React from 'react';
import PropTypes from 'prop-types';
import PaymentInformationCheckDisplay from './PaymentInformationCheckDisplay';
import PaymentInformationCreditDisplay from './PaymentInformationCreditDisplay';
import PaymentInformationFiservDisplay from './PaymentInformationFiservDisplay';
import { Form } from 'semantic-ui-react';
import numeral from 'numeral';

const PaymentSourceDisplay = ({ source, includeAmount }) => {
	function _source() {
		switch (source.type) {
			case 'credit':
				if (source.fiserv && source.fiserv.fundingAccountToken) {
					return <PaymentInformationFiservDisplay source={source} />;
				} else {
					return <PaymentInformationCreditDisplay source={source} />;
				}
			case 'check':
				return <PaymentInformationCheckDisplay source={source} />;
			default:
				//wallet
				return <PaymentInformationFiservDisplay source={source} />;
		}
	}

	return (
		<React.Fragment>
			{includeAmount ? (
				Object.keys(source.amounts).map((amountName, i) => {
					return <Form.Field>
					<label>Amount ({amountName})</label>
					<span>{numeral(source.amounts[amountName]).format('$ 0,0.00')}</span>
				</Form.Field>
				})
			) : null}
			{_source()}
		</React.Fragment>
	);
};

PaymentSourceDisplay.propTypes = {
	source: PropTypes.object.isRequired,
	includeAmount: PropTypes.bool
};

export default PaymentSourceDisplay;
